import { render, staticRenderFns } from "./tab_message.vue?vue&type=template&id=57c104fa&scoped=true&"
import script from "./tab_message.vue?vue&type=script&lang=js&"
export * from "./tab_message.vue?vue&type=script&lang=js&"
import style0 from "./tab_message.vue?vue&type=style&index=0&id=57c104fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c104fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c104fa')) {
      api.createRecord('57c104fa', component.options)
    } else {
      api.reload('57c104fa', component.options)
    }
    module.hot.accept("./tab_message.vue?vue&type=template&id=57c104fa&scoped=true&", function () {
      api.rerender('57c104fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/message/tab_message.vue"
export default component.exports